/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

const APPS_SKELETON_LAYOUTS = {
    DEFAULT: 'appsSkeletonDefault',
};

const BANNER_LAYOUTS = {
    FULL_WIDTH: 'fullWidth',
    FIFTY_FIFTY: 'fiftyFifty',
    SIXTY_FORTY: 'sixtyForty',
    TWO_THIRD_ONE_THIRD: 'twoThirdOneThird',
};

const BANNER_ITEM_LAYOUTS = {
    IMAGE_ONLY: 'imageOnly',
    VIDEO_ONLY: 'videoOnly',
    VIDEO_WITH_TEXT: 'videoWithText',
    CARD_LAYOUT: 'cardLayout',
    DEFAULT: 'default',
    TEXT_ONLY: 'textOnly',
    SEARCH_QUIET: 'searchQuiet',
    SEARCH_STANDARD: 'searchStandard',
    CONTEXT_BANNER: 'contextBanner',
    IMAGE_WITH_TEXT_ON_RIGHT: 'imageWithTextOnRight',
    IMAGE_WITH_TEXT_ON_LEFT: 'imageWithTextOnLeft',
};

const PDP_LAYOUTS = {
    DEFAULT: 'pdpDefault',
};

const APP_SECTION_LAYOUTS = {
    DEFAULT: 'appSectionDefault',
    LIST_VIEW: 'appSectionListView',
    CARD_VIEW: 'appSectionCardView',
    CARD_MEDIA_TAGLINE_VIEW: 'appSectionCardMediaTaglineView',
    CARD_MEDIA_TAGLINE_FEATURE_VIEW: 'appSectionCardMediaTaglineFeatureView',
    CARD_MEDIA_DESC_LEFT_VIEW: 'appSectionCardMediaDescLeftView',
    CARD_MEDIA_DESC_RIGHT_VIEW: 'appSectionCardMediaDescRightView',
};

const APPS_CATALOG_LAYOUTS = {
    DEFAULT: 'appsCatalogDefault',
    APP_CARDS: 'appCards',
};

export {
    BANNER_LAYOUTS,
    BANNER_ITEM_LAYOUTS,
    PDP_LAYOUTS,
    APPS_SKELETON_LAYOUTS,
    APPS_CATALOG_LAYOUTS,
    APP_SECTION_LAYOUTS,
};
